module.exports = __webpack_public_path__ + "media/foot_locker_scholar_athletes_program_2018/footlocker_fastweb-9c84a121.png";